import React, { useEffect, useState } from 'react'
import moment from 'moment';
import InsightsComponent from './details/InsightsComponent';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { tryToFetchInsights } from '../../../store/brokers/partner/agent-activities/agentActivitiesSlice';


const Insights = () => {
    const dispatch = useAppDispatch();
    const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
        null,
        null,
    ]);
    const [isOpen, setIsOpen] = useState(false);
    const logsStats = useAppSelector((state) => state?.agentActivities?.insights);

    const onGettingFilters = (stats?: boolean) => {
        let data: any
        if ((dateRange?.[0] !== null) || (dateRange?.[1] !== null)) {
            data = {
                ...data || {},
                fromDate: dateRange?.[0] ? moment(dateRange?.[0])?.format('YYYY-MM-DD') : dateRange?.[0],
                toDate: dateRange?.[1] ? moment(dateRange?.[1])?.format('YYYY-MM-DD') : dateRange?.[1]
            }
        }
        return data ? data  : {};
    }


    const onGettingStats = async () => {
        try {
            const data = onGettingFilters(true)
            await dispatch(tryToFetchInsights(data)).unwrap()
        } catch (err) {
            // err
        }
    }

    useEffect(() => {
        onGettingStats()
    }, [dateRange])

    const onChange = (newRange: any) => {
        if (Array.isArray(newRange) && newRange[0] && newRange[1]) {
            setDateRange([newRange[0], newRange[1]]);
            setIsOpen(false);
        }
    };

    const onRefreshData = () => {
        setDateRange([null, null])
    }

    return (
        <div>
            <p className='text-primary-light text-sm font-medium mb-10'>Insights</p>
            <InsightsComponent
                dateRange={dateRange}
                isOpen={isOpen}
                allStats={logsStats}
                setIsOpen={setIsOpen}
                onChange={onChange}
                onRefreshData={onRefreshData}
            />
        </div>
    )
}

export default Insights;